import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AbstractFilterModel } from '@gipi-pages/abstract/models/abstract-filter.model';
import { AbstractService } from '@gipi-pages/abstract/services/abstract.service';
import { TypeVersionModel } from '../models/type-version.model';

@Injectable({ providedIn: 'root' })
export class TypeVersionService extends AbstractService<TypeVersionModel, AbstractFilterModel> {

    constructor(protected httpClient: HttpClient) {
        super('APOIO', 'type-version', httpClient);
    }

}
